// extracted by mini-css-extract-plugin
export var contentBody = "_52-9";
export var headerImage = "_52-2";
export var imageButton = "_52-7";
export var imageButtonIcon = "_52-8";
export var imageHeader = "_52-4";
export var imageHeaderText = "_52-5";
export var imageOverlay = "_52-3";
export var imageTitle = "_52-6";
export var imageWrapper = "_52-1";
export var taskList = "_52-a";
export var widget = "_52-0";